import LocalizationStore from '../Stores/LocalizationStore'

export enum DownloadDocumentType {
    Magnit_Act = 0,
    Magnit_Contract = 1,
    Sky_Act = 2,
    Sky_Istanbul = 3,
    Sky_Client = 4,
    Sky_Contract = 5,
    Payment_Schedule = 6,
    AfnMmcAgreement = 7,
    ConsentApplication = 8,
    ChangesAct = 9,
    RefusalAct = 10,
    DeliveryMoped = 11,
    FinancialReference = 12,
    AfnTrade = 13,
}

export function getDocumentTemplateTypeText(type: string): string {
    return LocalizationStore.getInstance().t(type)
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Model/DownloadDocumentType.ts